module.exports = "/* Estilos para create-user-modal component */\n"